module.exports = __webpack_public_path__ + "static/media/mascote-chase-patrulha-pata@2x.21c5b308.jpg";